import React from 'react';
import { Wrench, Droplets, Waves, Container, Camera, Search, Trash2, Settings, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';
import { Button } from './ui/button';

const iconMap = {
  Wrench,
  Droplets,
  Waves,
  Container,
  Camera,
  Search,
  Trash2,
  Settings
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white via-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Nos Prestations
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Services de <span className="text-sky-600">Débouchage</span> & <span className="text-teal-600">Assainissement</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Une gamme complète de services pour tous vos problèmes de canalisations et d'assainissement
          </p>
        </div>

        {/* Services List */}
        <div className="space-y-12">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            const isEven = index % 2 === 0;
            
            return (
              <div
                key={service.id}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}
              >
                {/* Service Card */}
                <div className="flex-1 w-full">
                  <div className="bg-gradient-to-br from-sky-600 to-teal-600 rounded-2xl p-8 text-white shadow-xl hover:shadow-2xl transition-all duration-300">
                    <div className="flex items-start gap-4 mb-4">
                      <div className="w-14 h-14 rounded-xl flex items-center justify-center bg-white/20 flex-shrink-0">
                        <Icon className="text-white" size={28} />
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-white">
                          {service.title}
                        </h3>
                        <div className="text-2xl font-bold text-lime-300 mt-1">
                          {service.price}
                        </div>
                      </div>
                    </div>
                    
                    <p className="text-sky-100 mb-6 leading-relaxed">
                      {service.description}
                    </p>

                    {/* Features list */}
                    <ul className="grid grid-cols-2 gap-2 mb-6">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="text-sm flex items-center gap-2 text-sky-100">
                          <span className="w-2 h-2 rounded-full bg-lime-400 flex-shrink-0" />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <a href="#contact">
                      <Button 
                        className="bg-white text-sky-700 hover:bg-sky-50 font-semibold py-3 px-6 rounded-xl transition-all duration-300"
                      >
                        Demander un devis
                        <ArrowRight size={16} className="ml-2" />
                      </Button>
                    </a>
                  </div>
                </div>

                {/* Service Image */}
                <div className="flex-1 w-full">
                  {service.image ? (
                    <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                      <img 
                        src={service.image} 
                        alt={service.title}
                        className="w-full h-[350px] object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                        decoding="async"
                        width="600"
                        height="350"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-sky-900/60 via-transparent to-transparent" />
                      <div className="absolute bottom-4 left-4 right-4">
                        <span className="bg-lime-500 text-gray-900 px-3 py-1 rounded-full text-sm font-semibold">
                          {service.title}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="w-full h-[350px] rounded-2xl bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
                      <div className="text-center text-slate-400">
                        <Icon className="mx-auto mb-3" size={48} />
                        <p className="text-sm">Photo à venir</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
